import { render, staticRenderFns } from "./incomeList.vue?vue&type=template&id=4628ad9a&scoped=true&"
import script from "./incomeList.vue?vue&type=script&lang=js&"
export * from "./incomeList.vue?vue&type=script&lang=js&"
import style0 from "./incomeList.vue?vue&type=style&index=0&id=4628ad9a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4628ad9a",
  null
  
)

export default component.exports